import { render, staticRenderFns } from "./GoogleAuthentication.vue?vue&type=template&id=5109c96d"
import script from "./GoogleAuthentication.vue?vue&type=script&lang=js"
export * from "./GoogleAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports